<template>
<div>
    <el-row class="cs-filter-row">
        <el-col class="text-left">
            <el-button class="cs-pagination-header-add" type="primary" plain icon="el-icon-plus" @click="addSpeedupTerm">添加学期</el-button>
        </el-col>
    </el-row>
    <el-row class="grid-content">
        <el-col>
            <el-table ref="termTable" v-loading="loading" :data="currentPageTerms" :header-row-class-name="'el-table-header'" :cell-class-name="cellStyle">
                <el-table-column prop="DisplayLable" label="学期列表" fixed :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="IsCurrentTerm" label="当前学期" fixed :min-width="columnWidth">
                    <template slot-scope="scope">
                        <span v-if="scope.row.IsCurrentTerm">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="PreRecruiteDateStr" label="提前招生" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week1" label="WEEK 1" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week2" label="WEEK 2" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week3" label="WEEK 3" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week4" label="WEEK 4" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week5" label="WEEK 5" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week6" label="WEEK 6" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week7" label="WEEK 7" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week8" label="WEEK 8" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week9" label="WEEK 9" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week10" label="WEEK 10" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week11" label="WEEK 11" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week12" label="WEEK 12" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week13" label="WEEK 13" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Week14" label="WEEK 14" :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="Name" label="编辑" fixed="right" :min-width="80">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="onEditTerm(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="20" layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
            </el-pagination>
        </el-col>
    </el-row>
    <el-dialog title="" :center="true" :close-on-click-modal="false" width="40%" :visible.sync="displayTermEditor" top="5vh">
    <termEditor ref="termEditor" :mode="editMode" :editingForm="editingForm" :currentTerm="currentTerm" :isVisible="displayTermEditor" v-on:saveTermSuccess="onSaveTermSuccess" v-on:dialogFormVisibleEvent="onTermEditorVisibleEvent"></termEditor>
</el-dialog> 
</div>  
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    .grid-content {
        margin-top: 15px;

        .cs-schedule-buttonContainer {
            text-align: right;
        }
    }

    .gray {
        color: gray;
    }
}
.cs-filter-row{
    padding-top: 20px;
}
</style>

<script>
import navigator from "../../components/navigator";
import termEditor from "../../components/termManagement/termEditor";
import {
    getAllTerms
} from "../../service/termManage.service.js";
import {
    getCurrentTerm
} from "../../service/common.service.js";
import {
} from "../../config/mUtils.js"; 
export default {
    data() {
        return {
            speedupTerms: [],
            currentPageTerms: [],
            loading: false,
            columnWidth: 110,
            currentPage: 1,
            currentPageSize: 20,
            recordTotal: 0,
            editMode: "add",
            editingForm: {},
            displayTermEditor: false,
            currentTerm: {}
        }
    },
    components: {
        navigator,
        termEditor
    },
    created() {
        this.loadTerms();
        getCurrentTerm().then(result => {
            if (!!result && result.success) {
                this.currentTerm = result.data;
            }
        }); 
    },
    methods: {
        cellStyle(cell) {
            let cellClass = "";
            if ((cell.rowIndex + 1) % 2 == 1) {
                cellClass = "el-table-cell-single";
            } else {
                cellClass = "el-table-cell-double";
            }
            return cellClass;
        },
        getColumnWidth(value) {
            if (!value) {
                return 150;
            }
            return value;
        },
        loadTerms() {
            this.loading = true;
            getAllTerms().then(result => {
                if (!!result && result.success) {
                    this.speedupTerms = result.data;
                    this.recordTotal = this.speedupTerms.length;
                    this.getCurrentPageTerms();
                }
                this.loading = false;
            })
        },
        getCurrentPageTerms() {
            let start = (this.currentPage - 1) * this.currentPageSize;
            let end = start + this.currentPageSize;
            this.currentPageTerms = this.speedupTerms.slice(start, end);
        },
        handleSizeChange(value) {
            this.currentPageSize = value;
            this.currentPage = 1;
            this.getCurrentPageTerms();
        },
        handleCurrentChange(index) {
            this.currentPage = index;
            this.loadTerms();
            this.getCurrentPageTerms();
        },
        addSpeedupTerm() {
            this.editMode = "add";
            this.editingForm = null;
            this.displayTermEditor = true;
        },
        onEditTerm(row) {
            this.editMode = "edit";
            this.editingForm = row;
            this.displayTermEditor = true;
        },
        onTermEditorVisibleEvent() {
            this.displayTermEditor = false;
            this.$refs.termEditor.close();
        },
        onSaveTermSuccess() {
            this.displayTermEditor = false;
            this.loadTerms()
        },
    },
    watch: {
        displayTermEditor: function () {
            if (!this.displayTermEditor) {
                this.onTermEditorVisibleEvent();
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/termManagement/universityTerms.vue